import { render } from "./ButtonSubmit.vue?vue&type=template&id=31b2192e&scoped=true"
import script from "./ButtonSubmit.vue?vue&type=script&lang=js"
export * from "./ButtonSubmit.vue?vue&type=script&lang=js"

import "./ButtonSubmit.vue?vue&type=style&index=0&id=31b2192e&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b2192e"]])

export default __exports__